import { put, call } from 'redux-saga/effects';
import { mutate } from 'store/state/mutationsResponse/actions';
import { MutationType, LoadType } from 'store/sagas/apiService/types';
import { State as RouteState } from 'config/routes';
import { queryData } from 'store/sagas/apiService';

export function* unsubscribePageHandler(route: RouteState) {
  switch (route.params.type) {
    case 'saved-search':
      yield call(queryData, {
        loadType: LoadType.SearchByUserIdAndSearchId,
        meta: {
          variables: {
            token: route.params.token,
          },
        },
      });

      break;
    case 'marketing': {
      const isNewMarketingUnsubscribe = route.params.source === 'project_you_may_like';
      if (isNewMarketingUnsubscribe) {
        yield call(queryData, {
          loadType: LoadType.SearchByUserIdAndSearchId,
          meta: {
            variables: {
              token: route.params.token,
              isProjectEmail: true,
            },
          },
        });
      }
      else {
        yield put(mutate({
          meta: {
            variables: {
              input: {
                unsubscribeToken: route.params.token,
                source: route.params.source,
              },
            },
          },
          mutationType: MutationType.RemoveMarketingConsent,
        }));
      }
      break;
    }
    case 'promotionPlanDunningReminder':
      yield put(mutate({
        meta: {
          variables: {
            paymentIntentId: route.params.paymentIntentId,
            userToken: route.params.token,
          },
        },
        mutationType: MutationType.DisableRecoveryEmails,
      }));
      break;
    default:
      yield put(mutate({
        meta: {
          variables: {
            token: route.params.token,
            unsubscribe: true,
          },
        },
        mutationType: MutationType.SavedSearchUnsubscribe,
      }));
      break;
  }
}
